import React, { useEffect, useState } from "react";
import '../global.css'

import js from '../imgs/js.png'
import figma from '../imgs/figma.png'
import node from '../imgs/node-js.png'
import reactjs from '../imgs/physics.png'
import py from '../imgs/python.png'
import data_analicty from '../imgs/research.png'
import powerBI from '../imgs/Power BI.png'


import moment from "moment";
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai'
import Lottie from 'react-lottie-player'

import devAnimation from '../json/dev.json'

export default function HomePage() {


    const [user, setUser] = useState([])
    const [repos, setRepos] = useState([])

    // const Dow_CV = 'https://export-download.canva.com/vFvBw/DAFFC9vFvBw/44/0-29969354080.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAJHKNGJLC2J7OGJ6Q%2F20220702%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20220702T223227Z&X-Amz-Expires=25290&X-Amz-Signature=02b3c56136f0b3f2f944232b1fb05a1c75f15afa9c997cab84059d2f3ad71f42&X-Amz-SignedHeaders=host&response-content-disposition=attachment%3B%20filename%2A%3DUTF-8%27%27Ciro%2520Gomes.pdf&response-expires=Sun%2C%2003%20Jul%202022%2005%3A33%3A57%20GMT'
    const linkerdin = 'https://www.linkedin.com/in/ciro-gomes/'
    const my_gitHub = 'https://github.com/CiroGomess'



    function GetRepos(params) {
        fetch('https://api.github.com/users/CiroGomess/repos')
            .then(res => res.json())
            .then(data => {
              

                for (let i = 0; i < data.length; i++) {
                    if (data[i].name === 'CiroGomess') {
                        delete data[i]
                    }
                }
                data.sort(function (a, b) {
                    if (a.created_at > b.created_at) {
                        return -1
                    }
                    return 0
                })

                setRepos(data.slice(0, 8))
            })
    }

    function GetUser(params) {
        fetch('https://api.github.com/users/CiroGomess')
            .then(res => res.json())
            .then(data => {
              
                setUser(data)
            })
    }


    useEffect(() => {
        GetUser()
        GetRepos()
    }, [])


    return (
        <div >
            <div className="info-initial ">

                <header >
                    <p className='name-dev'> {"<"} CIRO <span>DEV</span> {"/>"}</p>

                    <nav>
                        <ul>
                            <a href="/#skill" rel="noopener noreferrer">
                                <li>Skills</li>
                            </a>
                            <a href="/#project" rel="noopener noreferrer">
                                <li>Projetos</li>
                            </a>
                            <a href="/#contact" rel="noopener noreferrer">
                                <li>Contato</li>
                            </a>
                        </ul>
                    </nav>

                </header>

                <section className='container-info-img'>

                    <div>
                        <h2>Cientista de Dados e IA</h2>
                        <p>
                            {user.bio}
                        </p>



                    </div>

                    <Lottie
                        loop
                        animationData={devAnimation}
                        play
                        style={{ width: 1000, height: 500 }}
                    />

                    {/* <img src={developer} alt="App Cartão Nordeste" srcset="Cartão Nordeste" className="img-store" /> */}

                </section>

                <div className="box">
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />

                </div>


            </div>


            <section className="container-projetos-skills" id="skill">
                <h2>Skills</h2>

                <div className="containerSkills">
                    <div>
                        <img src={js} alt="JS" />
                        <p>JavaScript</p>
                    </div>
                    <div>
                        <img src={data_analicty} alt="analise dados" />
                        <p>Data analysis</p>
                    </div>
                    <div>
                        <img src={powerBI} alt="analise dados" />
                        <p>Power BI</p>
                    </div>
                    <div>
                        <img src={py} alt="python" />
                        <p>Python</p>
                    </div>
                    <div>
                        <img src={figma} alt="Figma" />
                        <p>Figma</p>

                    </div>
                    <div>
                        <img src={reactjs} alt="reactjs" />
                        <p>ReactJS</p>
                    </div>
                    <div>
                        <img src={reactjs} alt="react native" />
                        <p>React Native</p>
                    </div>
                    <div>
                        <img src={node} alt="nodejs" />
                        <p>NodeJS</p>
                    </div>

                </div>



            </section>


            <section className="container-projetos"  id="project">
                <h2>Projetos</h2>


                <div className="info-projeto">

                    {repos.length > 0 ? repos.map((value, i) => (

                        <a href={value.clone_url} target='_blank' rel="noopener noreferrer">
                            <div key={i}>
                                <h3>{value.name}</h3>
                                <p>Data: {moment.utc(value.created_at).format("DD/MM/YYYY")}</p>
                                <p>{value.language}</p>
                            </div>
                        </a>
                    )) : <></>}


                </div>
            </section>

            <hr />

            <footer className="container-footer"  id="contact">
                <div className="info-img-data-user">

                    <div className="img-user">

                        <img src={user.avatar_url} alt="" />
                    </div>

                    <div>
                        <a href={my_gitHub} target='_blank' rel="noopener noreferrer">
                            <AiFillGithub size={35} />
                        </a>

                        <a href={linkerdin} target='_blank' rel="noopener noreferrer">
                            <AiFillLinkedin size={35} />
                        </a>


                    </div>

                </div>

                <div className="user-text">

                    <p>
                        Lembre-se de que você mesmo é o melhor secretário de sua tarefa,
                        o mais eficiente propagandista de seus ideais, a mais clara demonstração de s
                        eus princípios, o mais alto padrão do ensino superior que seu espírito abraça e a
                        mensagem viva das elevadas noções que você transmite aos outros. Não se esqueça,
                        igualmente, de que o maior inimigo de suas realizações mais nobres, a completa
                        ou incompleta negação do idealismo sublime que você apregoa, a nota discordante
                        da sinfonia do bem que pretende executar, o arquiteto de suas aflições e o destruidor de
                        suas oportunidades de elevação - é você mesmo.
                    </p>
                    <h6>Chico Xavier</h6>
                </div>
            </footer>

        </div>
    );
}
